// ABOUTME: React Query hooks for game state queries and mutations
// ABOUTME: Manages player level, XP, streaks, and achievements

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { queryKeys } from './queryKeys'

interface GameState {
  id: string
  level: number
  xp: number
  streakDays: number
  lastActive: string | null
  achievements: string | null
  stats: string | null
  levelAcknowledged: number
  updatedAt: string
}

export function useGameState(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.gameState.all,
    queryFn: () => api.get<GameState>('/api/v1/game-state'),
    enabled: options?.enabled,
  })
}

export function useUpdateGameState() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: Partial<{
      level: number
      xp: number
      streakDays: number
      lastActive: string
      achievements: string
      stats: string
      levelAcknowledged: number
    }>) => api.put<GameState>('/api/v1/game-state', data),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.gameState.all })
    },
  })
}
